import { DISPUTE_STATUS_LABELS } from '@/features/contracts/constants/dispute-labels';

interface DisputeBadgeProps {
  /** État Stripe du dernier litige du contrat (`needs_response`, `won`, `lost`…). */
  status: string;
}

/**
 * Pastille « Litige » de la liste des contrats, à côté du statut : le contrat a au
 * moins un litige Stripe. L'info-bulle donne l'état du dernier.
 */
export function DisputeBadge({ status }: DisputeBadgeProps) {
  const stateLabel = DISPUTE_STATUS_LABELS[status]?.label ?? status;

  return (
    <span
      title={`Litige : ${stateLabel}`}
      className="tw-inline-flex tw-items-center tw-px-2.5 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-bg-rose-100 tw-text-rose-800"
    >
      Litige
    </span>
  );
}
